import React from "react";
import TypingText from "../utils/TypingText";

export default function AdventureOverview() {
  return (
    <section className="relative w-full bg-white py-16 sm:py-24 px-4 sm:px-6 flex flex-col items-center overflow-hidden">

      {/* BACKGROUND WATERMARK */}
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none select-none leading-none">
      <h1
  className="
    font-bold text-gray-300/20 tracking-tight leading-none text-center
    pointer-events-none select-none
  "
  style={{ fontSize: "clamp(4rem, 15vw, 12rem)" }}
>
  BROADBOY
</h1>
<h1
  className="
    font-bold text-gray-300/20 tracking-tight leading-none text-center -mt-8 sm:-mt-10
    pointer-events-none select-none
  "
  style={{ fontSize: "clamp(4rem, 15vw, 12rem)" }}
>
  ADVENTURES
</h1>

      </div>

      {/* Decorative top lines and circle */}
      <div className="flex items-center mb-6 sm:mb-8 relative z-10">
        <div className="h-[1px] w-12 sm:w-16 bg-gray-800" />
        <div className="rounded-full border border-gray-800 w-5 h-5 sm:w-6 sm:h-6 mx-3 sm:mx-4" />
        <div className="h-[1px] w-12 sm:w-16 bg-gray-800" />
      </div>

      {/* Small heading */}
      <h2 className="text-center text-gray-800 text-base sm:text-lg md:text-xl mb-2 relative z-10">
        Your idyllic vacation retreat
      </h2>

      {/* Main Heading */}
      <h1 className="text-center text-3xl sm:text-4xl md:text-6xl font-serif font-bold mb-6 text-gray-700 relative z-10">
        Broadboy Adventures
      </h1>

      {/* Paragraph */}
      <p className="max-w-xl sm:max-w-2xl text-center text-gray-700 mb-8 relative z-10 text-sm sm:text-base md:text-lg leading-relaxed">
        <TypingText
          speed="0.02"
          text="Embark on unforgettable journeys with Broad Boy Adventures, 
          where every trek and expedition reveals the raw beauty of the world.
          From soaring mountains to serene lakes, experience luxury, thrill, and adventure like never before."
        />
      </p>

      {/* CTA */}
      <a
        href="./contact"
        target="_blank"
        rel="noopener noreferrer"
        className="px-6 sm:px-8 py-2 sm:py-3 rounded-full border border-gray-800 text-gray-800 font-medium hover:bg-gray-800 hover:text-white transition relative z-10 text-sm sm:text-base"
      >
        BOOK YOUR TRIP
      </a>
    </section>
  );
}
